module.exports = __webpack_public_path__ + "566c62778e4dd35b9b161b030399a135.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cart/img/sidebar_empty_state_diamond.png
// module id = 793
// module chunks = 0